module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Rheingau-e3d0d15565dd929eead80a5a3873b312.jpeg";